import { SERVER_URL } from "../constants/constants.js";
import { customFetch } from "../components/common/fetchWrapper";

export const notesService = {
  getNotes,
};

async function getNotes(org_id, deal_jacket_id) {
  const url = SERVER_URL + "/org/" + org_id + "/dealjacket/" + deal_jacket_id + "/notes";
  return await customFetch("GET", url, null, null);
}
